import { MediaItem } from '../../types/post.types';

interface MediaGalleryProps {
  media?: MediaItem[];
}

export function MediaGallery({ media }: MediaGalleryProps) {
  if (!media || media.length === 0) return null;

  return (
    <div className="mt-2 grid gap-2">
      {media.length === 1 ? (
        <SingleMedia item={media[0]} />
      ) : (
        <div className={`grid grid-cols-2 gap-2 ${media.length > 2 ? 'grid-rows-2' : ''}`}>
          {media.map((item, index) => (
            <div
              key={item.id || index}
              className={`relative ${
                media.length === 3 && index === 2 ? 'col-span-2' : ''
              }`}
            >
              <SingleMedia item={item} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function SingleMedia({ item }: { item: MediaItem }) {
  const originalVariant = item.variants.find((v) => v.type === 'original');
  const webVariant = item.variants.find((v) => v.type === 'web') || originalVariant;

  if (!webVariant) return null;

  if (item.type === 'video') {
    return (
      <video
        src={webVariant.url}
        controls
        className="w-full rounded-lg object-cover"
        style={{ maxHeight: '512px' }}
      />
    );
  }

  return (
    <img
      src={webVariant.url}
      alt=""
      className="w-full rounded-lg object-cover"
      style={{ maxHeight: '512px' }}
    />
  );
}
